import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";

import { ContentItemArticleWidget } from "scmp-app/components/content/content-item-render/variants/article-widget";

export const StyledContentItemArticleWidget = styled(ContentItemArticleWidget)`
  margin-block-start: 8px;
  padding-block-start: 8px;
  border-block-start: 1px #dfdfdf solid;
`;

export const Title = styled.div`
  color: #333333;
  font-weight: 500;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
  font-style: normal;
  line-height: normal;
  text-transform: uppercase;
`;

export const Container = styled.div`
  display: flex;
  flex-flow: column nowrap;

  padding-block-start: 12px;
  border-block-start: 1px solid #dfdfdf;

  ${Title}+${StyledContentItemArticleWidget} {
    margin-block-start: 0;
    border-block-start: none;
  }
`;
